import { Spinner } from "@chakra-ui/react";
import { useContext, useState } from "react"
import { BiBarChart, BiSlider } from "react-icons/bi";
import { BsBarChart, BsBarChartFill, BsFileEarmarkExcel } from "react-icons/bs";
import { Button, ButtonLoading, ButtonToggle } from "../../../components/button/Button";
import { FeatureContext } from "../../../Context"
import { lang, useBfGlobals } from "../../../Utils";
import { StatusList } from "../components/StatusList";
import { downloadOrders } from "../Services";

const Actions = () => {
  const globals = useBfGlobals();
  const context = useContext(FeatureContext);

  return <div className="bf-actions-wrapper">
    <StatusList lang={lang} status={globals.get('orders_status.orders')} labels={globals.get('orders_status_description')} />
    <div className="bf-actions">
      <Button disabled={!context?.orders?.data} variant="default" onClick={context.toggleFilters}>
        <BiSlider /><span>{lang('Filters')}</span>
      </Button>
      <ButtonToggle
        disabled={!context?.orders?.data} 
        on={<BsBarChartFill />}
        off={<BsBarChart />}
        onClick={context.toggleCharts} />
      <ButtonLoading
        disabled={!context?.orders?.data}
        callback={downloadOrders}
        args={{ startDate: context?.filters?.startDate, endDate: context?.filters?.endDate }}
        icon={<BsFileEarmarkExcel />}
        label={lang('Excel')} />
    </div>
  </div>
}

export default Actions;